(() => {
  if (typeof window === 'undefined') return;

  const observe = () => {
    const els = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    els.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', observe);
})();

// Hero load-in choreography is pure CSS (hero-rise / hero-fade-rise keyframes
// in theme.css). It must not be triggered from JS: this script is deferred, so
// a class toggle here holds the hero logo — the LCP element — invisible until
// DOMContentLoaded, which cost ~10 s of LCP on throttled mobile.

// Border-draw button: size the SVG path to the actual button perimeter
(() => {
  const INSET = 4;

  const measure = (btn) => {
    const svg = btn.querySelector('.btn-border-svg');
    const path = svg && svg.querySelector('path');
    if (!svg || !path) return;

    const rect = btn.getBoundingClientRect();
    const w = Math.max(0, rect.width - INSET * 2);
    const h = Math.max(0, rect.height - INSET * 2);
    if (w === 0 || h === 0) return;

    svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    path.setAttribute('d', `M 0 0 L ${w} 0 L ${w} ${h} L 0 ${h} L 0 0`);

    const perimeter = 2 * (w + h);
    btn.style.setProperty('--btn-perimeter', perimeter + 2);
  };

  const init = () => {
    const buttons = document.querySelectorAll('.btn-border-draw');
    buttons.forEach(measure);

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver((entries) => {
        entries.forEach((entry) => measure(entry.target));
      });
      buttons.forEach((btn) => ro.observe(btn));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
